const tagColors = {
  Python: "#cdeac0",
  Java: "#EFDFDA",
  Javascript: "#E8DFEE",
  React: "#D4E6EE",
  CSS: "#d7e3fc",
  C: "#e2e2e2",
  Docker: "#fcf4dd",
  Postman: "#F2AEBB",
  R: "#CAE7E3",
  EDA: "#E7CBA9",
  HTML: "#FFBDBD",
  JavaScript: "#F5F3E7",
  GeoSpatial: "#F5E2E4",
  SQL: "#F7F6CF",
  AWS: "#bad7f2",
  "Healthcare Data Analysis": "#E3E4FA",
  Excel: "#B3D9D9",
  "Web Scraping": "#F3E3C3",
  ReactJS: "#B3C8CF",
  NodeJS: "#DBDFAA",
  API: "#E5BEB5",
  "Blockchain data": "#BCCDCF",
  Classification: "#F5E8DD",
  Pipeline: "#DFCCFB",
  "Data QA": "#C4C1A4",
  Airflow: "#F9F9E0",
  "Apache Spark": "#dfe7fd", //"#E7E8D8",
  Solana: "#CADCAE",
  "Machine Learning": "#bee1e6",
  DNN: "#e3d5ca",
  "Neural Networks": "#C0C9EE",
  TensorFlow: "#fcd5ce",
  Keras: "#f9e5d8",
  CNN: "#dcedc1",
  "Image Processing": "#f2ebfb",
  Segmentation: "#c2e2ea",
  "Data Cleaning": "#FFEBD4",
  RDBMS: "#bde0fe",
  JSON: "#dbcdf0",
  MapReduce: "#afd3ed",
  Hadoop: "#9fbdf5",
  "GeoSpatial Data": "#D6DAC8",
  "Spatial Analysis": "#fad2e1",
  "Hypothesis Testing": "#CADCAE",
  Clustering: "#efcfe3",
  ggplot: "#eec6ca",
  Packages: "#bad7f2",
  YOLO: "#ded6d1",
  RNN: "#a7bed3",
  Tableau: "#d2d2ff",
  "CI/CD": "#E7D3D3",
  Terraform: "#dabfff",
  "Database Migration": "#dec0f1",
  FinOps: "#d999b9",
  "D3.js": "#fbc4ab",
  ArcGIS: "#fec5bb",
  Highcharts: "#bbd0ff",
  Flourish: "#ffe5ec",
  "Data Storytelling": "#cddafd",
  "Data Journalism": "#ffc09f",
  "Database Design": "#CADCAE",
  Quicksight: "#79addc",
  "AWS Glue": "#eccbd9",
  "AWS Athena": "#b8b3e9",
  "Data Pipeline": "#d4e09b",
  PostgreSQL: "#CBDCEB",
  "Schema Transformation": "#D9E9CF",
  Typeform: "#93BFCF",
  Dashboarding: "#D3CEDF",
};
export default tagColors;
